/* eslint-disable jsx-a11y/media-has-caption */
import React from 'react';
import PropTypes from 'prop-types';
import Layout from 'components/layout';
import Head from 'components/head';
import { Heading, Text, Flex } from '@chakra-ui/react';
import Proyectos from '../../components/proyectos';
import { Link } from 'gatsby';
// import { VideoSchema } from '../../helpers/schemaGenerator';
import ContactBanner from '../../components/contactBanner';
import { StaticImage } from 'gatsby-plugin-image';
import ogImg from '../../../content/images/servicios/capacitacion/capacitacion-realidad-virtual-p.jpg';

const Capacitacion = ({ lang='es' }) => {
  const l = (...texts) => lang === 'en' ? texts[1] : texts[0]

  const pageTitle = l('🥽 Capacitación con Realidad Virtual y Realidad Mixta - Entrenamiento inmersivo', '🥽 Virtual Reality and Mixed Reality Training')
  const pageImage =
    'https://visualma.com' + ogImg
  const pageDescription = l('Somos proveedores de Capacitación con Realidad Virtual (VR), Realidad Aumentada (AR) y Realidad Mixta (MR) en México.',
    'We build training experiences using Virtual Reality (VR), Augmented Reality (AR) & Mixed Reality (MR).')
  // const pageUrl = 'https://visualma.com/capacitacion-realidad-virtual';
  const WideImgProps = {
    layout: 'fullWidth',
    width: 1024,
    formats: ['auto', 'webp', 'avif'],
  }
  const MedImgProps = {
    layout: 'fullWidth',
    width: 800,
    height: 450,
    formats: ['auto', 'webp', 'avif'],
  }
  
  return (
    <Layout lang={lang}>
      <Head lang={lang}
        pageTitle={pageTitle}
        imageUrl={pageImage}
        pageDescription={pageDescription}
      />
      {/* <VideoSchema
        videoUrl="https://www.youtube.com/embed/goiihJ5cRLI"
        contentUrl={pageUrl}
        imageUrl={pageImage}
        title={pageTitle}
        description={'Ejemplos de Realidad virtual en México creados por la agencia Visualma'}
        date="2020-07-07T00:21:41Z"
        duration="PT52S"
      /> */}

      <div>

        {/* ----- HeroImage ----- */}
        <Flex justifyContent="flex-end">
          <h2 className="pageHeader">
            {l(<><b>Capacitación con Realidad Virtual</b> en México</>,
              <><b>Virtual Reality Training</b></>)}
          </h2>
        </Flex>

        <StaticImage
          className="headerImg"
          layout="fullWidth"
          formats={['auto', 'webp', 'avif']}
          loading="eager"
          src="../../../content/images/servicios/capacitacion/capacitacion-realidad-virtual-p.jpg"
          alt={l('Capacitación con Realidad Virtual en México', 'Virtual Reality Training')}
        />

        <Flex className="headerTitleWrapper">
          <div>
            <h1 className="parrafo parrafoGrande headerTitle">
              {l(<> <b>Capacitación con Realidad Virtual en México</b></>,
                <><b>Virtual Reality Training</b></>)}
            </h1>
          </div>
        </Flex>
        {/* ----------------------- */}

        <p className="parrafo">
          {l(<>Creamos experiencias didácticas que utilizan la <Link to="https://visualma.com/realidad-virtual" style={{fontWeight: 'bold'}}>Realidad Virtual</Link> como una herramienta invaluable e integral para el entrenamiento de empleados.</>,
          <>We create training experiences that use <Link to="https://visualma.com/en/virtual-reality">Virtual Reality</Link> as an invaluable and integral tool for employee training.</>)}
        </p>
          
{/* 
  <div className="">
    <Box m="o auto" textAlign="center">
      <video
        controls={false}
        width="960px"
        loading="lazy"
        autoPlay
        loop
        playsInline
        muted
        controlsList="nodownload"
        crossOrigin="anonymous"
        alt="Video de lentes de Realidad virtual y ecenarios 3d"
        title="Video de lentes de Realidad virtual y ecenarios 3d"
        style={{margin: '0 auto', maxWidth: '100%'}}  
      >
        <source src="https://player.vimeo.com/external/462052381.hd.mp4?s=6b6efe77dfabcc13f9ffa7621c42b65ac2602408&profile_id=175"
          type="video/mp4" />
        Tu navegador no soporta videos.
      </video>
    </Box>
  </div> */}

        
<div className="mainContainer">
    <h2 className="subHeader subHeaderSmall" style={{textAlign: 'center'}}>
      <small>
      {l(<>¿Que es la capacitación inmersiva <br/>con realidad virtual?</>,
      'What is immersive training with virtual reality?')}
      </small>
    </h2>
    {l(<>
      El entrenamiento inmersivo o capacitación con realidad virtual es una tecnología demostrada que ofrece ahorros en tiempo y presupuesto a empresas globales, mejorando los resultados de sus entrenamientos:
      <ul style={{marginTop: '0.5em'}}>
        <li>Capacitación más ágil con menor tasa de error</li>
        <li>Reduce accidentes y aumenta involucramiento</li>
        <li>Alto retorno de inversión</li>
      </ul>
      Mostraremos cómo podemos sumar el VR y AR a sus procesos existentes para obtener mejores resultados.
    </>,
    <>
      Immersive training is a tested technology that offers savings in time and budget to global companies, improving the results of their training:
      <ul>
        <li>Smarter trainings with lower error rate</li>
        <li>Reduces accidents and increases involvement</li>
        <li>High return on investment</li>
      </ul>
      We will show how we can add VR and AR to existing processes to get better results.
    </>)}
    <br/><br/>
    <div className="contenidoSmall" style={{borderRadius: '12px', overflow: 'hidden', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
    <StaticImage {...WideImgProps}
      src="../../../content/images/servicios/capacitacion/realidad-virtual-fabrica.jpg"
      alt={l('persona con gafas de realidad virtual', 'Person with vr glasses')}
      layout="fullWidth"
    />
    </div>
    <br/><br/>
    <h2 className="subHeader subHeaderSmall" style={{textAlign: 'center'}}>
      <small>
      {l('¿Como funciona la capacitación VR?',
      'How does immersive VR training work?')}
      </small>
    </h2>
    {l(<p>
        El entrenamiento inmersivo con VR y AR está creado desde su origen para ofrecer aprendizajes activos y experienciales.
        <br/><br/>
          Utilizando dispositivos como cascos y tabletas, colocamos al usuario dentro de espacios hiperrealistas en los que puede experimentar situaciones, escenarios y problemas ilustrativos en un entorno simulado.
        <br/><br/>
        Ofrecemos las ventajas del aprendizaje experiencial sin los costos, tiempos y riesgos usualmente asociados.
      </p>,
      <p>
        The immersive training with VR and AR was created from its origin to offer active learning and didactive experiences.
        <br/><br/>
        Using devices like goggles and tablets, we put the user inside hyperrealistic spaces in which they can experience situations, scenarios and illustrative problems in a simulated environment.
        <br/><br/>
        We offer the advantages of experiential learning without the usual costs, times and risks associated with it.
      </p>)}
      <br/><br/>
      <div style={{borderRadius: '12px', overflow: 'hidden', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
        <StaticImage {...WideImgProps}
          src="../../../content/images/servicios/capacitacion/capacitacionVR.jpg"
          alt={l('Persona entrenando con lentes de realidad virtual', 'Person training with vr glasses')}
          layout="fullWidth"
        />
      </div>
      <br/><br/>
      <h2 className="subHeader subHeaderSmall" style={{textAlign: 'left'}}>
        {l(<>Ventajas de la capacitación<br/> con realidad virtual</>,
          <>Advantages of immersive training<br/> with virtual reality</>)}
      </h2>
      {l(
        <ul style={{listStyle: 'none', paddingLeft: '0'}}>
          <li><a href="#retencion" style={{color: '#333'}}><b style={{color:'orange', fontWeight:'bold'}}>01</b> {l('Mejor retención', 'Better retention')}</a></li>
          <li><a href="#seguridad" style={{color: '#333'}}><b style={{color:'orange', fontWeight:'bold'}}>02</b> {l('Más seguridad','More security')}</a></li>
          <li><a href="#riesgo" style={{color: '#333'}}><b style={{color:'orange', fontWeight:'bold'}}>03</b> {l('Escenarios de riesgo','Risk scenarios')}</a></li>
          <li><a href="#costos" style={{color: '#333'}}><b style={{color:'orange', fontWeight:'bold'}}>04</b> {l('Efectivo en costos','Cost-effective')}</a></li>
          <li><a href="#escalable" style={{color: '#333'}}><b style={{color:'orange', fontWeight:'bold'}}>05</b> {l('Escalable','Scalable')}</a></li>
          <li><a href="#estandarizable" style={{color: '#333'}}><b style={{color:'orange', fontWeight:'bold'}}>06</b> {l('Consistente y estandarizáble','Consistent and standarizable')}</a></li>
          <li><a href="#comoCrear" style={{color: '#333'}}><b style={{color:'orange', fontWeight:'bold'}}>07</b> {l('Como crear una capacitación con realidad virtual','How to create a VR training')}</a></li>
        </ul>,
      )}
      
      <h3 id="retencion" className=" " style={{textAlign: 'left', marginTop: '2em'}}>
      &ldquo;{l(<>80% mejor retención <small>a largo plazo vs métodos tradicionales</small></>,
          <>80% better retention <small>over time vs traditional methods</small></>)}
        &rdquo;
      </h3>
      <p>
        {l('A diferencia de la lectura y los métodos de aprendizaje pasivo, visualizar escenarios en primera persona y contar con sonidos y herramientas de su entorno de trabajo, permite que los usuarios experimenten sensaciones reales y puedan aprender de sus errores y toma de decisiones a través de la experiencia.',
          'Unlike reading and passive training methods, VR allows users to experience real situations, visualize scenarios in first person and use sounds and tools from their work environment, allowing them to experience real sensations and to learn from their mistakes and decisions through the experience.')}
        <a href="https://trainingindustry.com/articles/learning-technologies/3-ways-virtual-reality-training-is-producing-better-outcomes/" target='_blank' rel="nofollow noopener noreferrer">*</a>
      </p>
      <br/><br/>
      <div className='iconList'>
        <div style={{marginRight: '1em'}}>
          <h4 className='' style={{textAlign: 'left'}}>{l('Experiencial', 'Experiential')}</h4>
          {l('Su diseño está basado en modelos de aprendizaje que involucran dimensiones emocionales, cognitivas, conductuales, kinestésicas y experienciales, integrando múltiples estilos de aprendizaje.',
            'Its design is based on models of learning that involve emotional, cognitive, physical, kinesthetic and experiential dimensions, integrating multiple styles of learning.')}
        </div>
        <div>
          <h4 className='' style={{textAlign: 'left'}}>{l('Activo', 'Active')}</h4>
          {l('El efecto inmersivo ayuda a fortalecer las conexiones cerebrales que traducen el entrenamiento en experiencia útil para las circunstancias que enfrentan los empleados en la vida real.',
            'The immersive effect helps to strengthen the brain connections that translate training into useful experience for the circumstances that employees face in real life.')}
        </div>
      </div>
       
      <Flex id="seguridad" className="flexList flexListCompacta">
        <Flex className="columna">
          <h3 className="subHeader subheaderSmall" style={{textAlign: 'left'}}>
            {l(<>Seguridad</>,
              <>More Security</>)}
          </h3>
          {l(<>
            El entrenamiento inmersivo permite la práctica activa de procedimientos de seguridad, uso de equipo y manejo de herramienta y maquinaria.
            <br/><br/>
            Se traduce en experiencia práctica y vivencial para los empleados, con resultados inmediatos y positivos:
            <br/><br/>
            <ul>
              <li>Reducción de accidentes</li>
              <li>Disminución de tasa de error en procesos</li>
            </ul>
          </>,
          <>
            Immersive training allows active practice of security procedures, use of equipment and handling of tools and machinery.
            <br/><br/>
            It translates into practical and safe experiences for employees, with immediate and positive results:
            <br/><br/>
            <ul>
              <li>Reduction of accidents</li>
              <li>Decrease in error rate in processes</li>
            </ul>
          </>)}
        </Flex>
        <Flex className="columna " style={{ marginTop: '1em'}}>
          <div style={{borderRadius: '12px', overflow: 'hidden', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
            <StaticImage {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/seguridad-entrenamiento-virtual.jpg"
              alt={l('Trabajadores capacitandose con lentes de realidad virtual', 'Workers training with vr glasses')}
              layout="fullWidth"
            />
          </div>
        </Flex>
      </Flex>
      
      <Flex className="flexList flexListCompacta" 
            flexDirection={['column-reverse', 'column-reverse', 'row']}    
        >
        <Flex className="columna "  >
        <div style={{borderRadius: '12px', overflow: 'hidden', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
          <StaticImage
            src="../../../content/images/servicios/capacitacion/tyson-vr.jpg"
            alt={l('trabajador entrenando con lentes de realidad virtual', 'Person with vr glasses')}
            layout="fullWidth"
          />
        </div>
        </Flex>
        <Flex className="columna" >
          <div style={{alignSelf: 'center'}}>
          La empresa Tyson vio un <b>20% de reducción en accidentes</b> de trabajo año con año después de implementar programas de entrenamiento y capacitación con realidad virtual. 
            <a href="https://thefeed.blog/2018/10/23/better-reality-through-virtual-reality-looking-to-the-future-of-workplace-safety/" target='_blank' rel="nofollow noopener noreferrer">*</a>
          </div>
        </Flex>
      </Flex>
      <Flex id="riesgo" className="flexList flexListCompacta">
        <Flex className="columna">
          <div style={{}}>
            <h3 className="subHeader subHeaderSmall" style={{textAlign: 'left'}}>
              {l(<>Escenarios de riesgo</>,
                <>Risk Scenarios</>)}
            </h3>
            La capacitacion con Realidad Virtual está únicamente posicionada para reproducir situaciones demasiado peligrosas, caras o complejas para ejecutar en la vida real.
            <br/><br/>
            Pilotos, personal de emergencia, de seguridad, trabajadores de industria pesada y médicos practican rutinariamente escenarios de alto riesgo que retan sus conocimientos y su toma de decisiones en situaciones críticas, para contar con estrategias que pueden salvar vidas.
          </div>
        </Flex>
        <Flex className="columna " >
          <div style={{borderRadius: '12px', overflow: 'hidden' ,marginTop: '1em', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/vrWorker.jpg"
              alt={l('Persona en fabrica tabajando con lentes de realidad virtual', 'Person working with vr glasses')}
              layout="fullWidth"
              style={{height: '100%'}}
            />
          </div>
        </Flex>
      </Flex>
      <Flex className="flexList flexListCompacta">
        <Flex className="columna " order={['2', '2', '1']}>
          <div style={{borderRadius: '12px', overflow: 'hidden', marginTop: '1em', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/vrEntrenamiento.jpg"
              alt={l('Experiencia de entrenamiento en realidad virtual', 'Training experience with vr glasses')}
              layout="fullWidth"
            />
          </div>
        </Flex>
        <Flex className="columna" order={['1', '1', '2']}>
          <div style={{ }}>
            <h3 className="subHeader subHeaderSmall" style={{textAlign: 'left'}}>
              {l(<>43% Tiempo ahorrado</>,
                <>43% Time saved</>)}
            </h3>
            {l('vs. retrasos por lesiones desde la introducción de entrenamientos de seguridad con realidad virtual en la industria minera.',
              'vs. delays due to injuries from the introduction of security training with vr in the mining industry.')}
          </div>
        </Flex>
      </Flex>
      <Flex id="costos" className="flexList flexListCompacta">
        <Flex className="columna">
          <div style={{ marginTop: '0em'}}>
            <h3 className="subHeader subHeaderSmall" style={{textAlign: 'left'}}>
              {l(<>Efectivo en costos</>,
                <>Cost effective</>)}
            </h3>
            {l('El entrenamiento inmersivo optimiza el proceso de capacitación con una atractiva propuesta de valor que reduce costos y ofrece un alto retorno de inversión:',
              'The immersive training optimizes the training process with an attractive value proposition that reduces costs and offers a high return on investment:')}
            <ul>
            {l(<>
                <li>Reduce la duración de las capacitaciones</li>
                <li>Mejor rendimiento de empleados vs. otros métodos</li>
                <li>Libera tiempo de personal clave</li>
                <li>Reduce costos derivados de daños y lesiones</li>
              </>,
              <>
                <li>Reduce the duration of training</li>
                <li>Higher employee performance vs. other methods</li>
                <li>Free up key staff time</li>
                <li>Reduce costs due to damage and injuries</li>
              </>)}
            </ul>
          </div>
        </Flex>
        <Flex className="columna ">
          <div style={{borderRadius: '12px', overflow: 'hidden', marginTop: '1em', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/capacitacion-realidad-virtual.jpg"
              alt={l('Grupo de persona entrenando con lentes de realidad virtual', 'Group of person with vr glasses')}
              layout="fullWidth"
            />
          </div>
        </Flex>
      </Flex>


      <h3 className="subHeader subHeaderSmall" style={{textAlign: 'left', marginTop: '2.5em'}}>
        {l(<>Resultados</>,
          <>Results</>)}
      </h3>
      <Flex wrap={'wrap'} justify={['center', 'center', 'flex-start']}>
      <Flex style={{flex: '1 1 300px', maxWidth: '270px', margin: '0.4em', marginBottom: '2.5em'}} flexDirection={'column'}>
          <div style={{maxWidth: '100%', marginBottom: '16px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/honeywell.png"
              alt={l('Honeywell logo', 'Honeywell logo')}
              layout='fullWidth'
            />
          </div>
          <p style={{fontSize: '0.8em'}}>
            {l(<><b>Reducción de costos operacionales de hasta 50%</b> en algunas áreas desde que implementaron programas de entrenamiento con realidad virtual.</>,
              <><b>Reducing operational costs up to 50%</b> in some areas since implementing security training with vr.</>)}
          </p>
        </Flex>
        <Flex style={{flex: '1 1 300px', maxWidth: '270px', margin: '0.4em', marginBottom: '2.5em'}} flexDirection={'column'}>
          <div style={{maxWidth: '215px', marginBottom: '16px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/airbus.png"
              alt={l('Airbus logo', 'Airbus logo')}
              height="12px"
              width="200px"
              layout='fullWidth'
            />
          </div>
          <p style={{fontSize: '0.8em'}}>
            {l(<><b>Redujo en 25%</b> la duración de sus procesos de mantenimiento al utilizar simulaciones de protocolos de mantenimiento en VR</>,
            <><b>25% Reduction</b> in maintenance process duration when using VR simulation of maintenance protocols</>
            )}
          </p>
        </Flex>
        <Flex style={{flex: '1 1 300px', maxWidth: '270px', margin: '0.4em', marginBottom: '2.5em'}} flexDirection={'column'}>
          <div style={{maxWidth: '200px', marginBottom: '16px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/boeing.png"
              alt={l('Boeing logo', 'Boeing logo')}
              layout='fullWidth'
            />
          </div>
          <p style={{fontSize: '0.8em'}}>
            {l(<><b>Reducción de 75%</b> en tiempo de entrenamiento de staff al implementar aprendizaje Inmersivo con realidad virtual</>,
              <><b>Reduction of 75%</b> in training time for staff when implementing Inmersive training with Virtual Reality</>)}
          </p>
        </Flex>

        <Flex style={{flex: '1 1 300px', maxWidth: '270px', margin: '0.4em', marginBottom: '2.5em'}} flexDirection={'column'}>
          <div style={{maxWidth: '170px', marginBottom: '16px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/intel.png"
              alt={l('Intel logo', 'Intel logo')}
              layout='fullWidth'
            />
          </div>
          <p style={{fontSize: '0.8em'}}>
            {l(<><b>ROI del 300%</b> a 5 años para el curso de certificación eléctrica de Intel, con el 94% de los empleados pidiendo más VR</>,
              <><b>ROI of 300%</b> in 5 years for the course of electrical certification of Intel, with 94% of the employees requesting more VR</>)}
          </p>
        </Flex>
        <Flex style={{flex: '1 1 300px', maxWidth: '270px', margin: '0.4em', marginBottom: '2.5em'}} flexDirection={'column'}>
          <div style={{maxWidth: '180px', marginBottom: '16px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/telestra.png"
              alt={l('Telestra logo', 'Telestra logo')}
              layout='fullWidth'
            />
          </div>
          <p style={{fontSize: '0.8em'}}>
            {l(<><b>Redujo en 50%</b> el tiempo requerido para completar los entrenamientos de seguridad de sus empleados.</>,
              <><b>50% Reduction</b> in time required for completing security training of their employees.</>)}
          </p>
        </Flex>
        <Flex>

        </Flex>  
      </Flex>
      
      <Flex id="escalable" className="flexList flexListCompacta">
        <Flex className="columna" >
          <div style={{}}>
            <h3 className="subHeader subHeaderSmall" style={{textAlign: 'left'}}>
              {l(<>Escalable</>,
                <>Scalable</>)}
            </h3>
            {l(<>
              El entrenamiento inmersivo vuelve accesible la capacitación experiencial a toda la fuerza de trabajo, independientemente de su ubicación geográfica, acceso a herramientas o maquinaria, y disponibilidad de personal experimentado.
              <br/><br/>
              Puede escalar de decenas a miles de empleados ya sea con experiencias individuales o bien con modalidades de multiusuario y telepresencia.
            </>,
              <>  
              The Inmersive training makes training accessible to all the workforce, regardless of their geographical location, access to tools or machinery, and available experienced staff.
              <br/><br/>
              It can scale from dozens to thousands of employees, either with individual experiences or with multiuser and telepresence modalities.
            </>)}
          </div>
        </Flex>
        <Flex className="columna " >
          <div style={{borderRadius: '12px', overflow: 'hidden', marginTop: '1em', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/entrenamiento-virtual.jpg"
              alt={l('Persona trabajando en su oficina con lentes de realidad virtual', 'Person working in his office with vr glasses')}
              layout="fullWidth"
            />
          </div>
        </Flex>
      </Flex>
      <Flex className="flexList flexListCompacta">
        <Flex className="columna ">
          <div style={{borderRadius: '12px', overflow: 'hidden', marginTop: '1em', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/entrenamiento-construccion-virtual.jpg"
              alt={l('Trabajador Visualizando una obra de construcción en vr', 'Worker Viewing a construction work in vr')}
              layout="fullWidth"
            />
          </div>
        </Flex>
        <Flex id="estandarizable" className="columna" >
          <div style={{}}>
            <h3 className="subHeader subHeaderSmall" style={{textAlign: 'left'}}>
              {l(<>Consistente y estandarizable</>,
                <>Consistent and standardized</>)}
            </h3>
            {l(<>
              El entrenamiento con realidad virtual y realidad aumentada otorga las mismas condiciones controladas de aprendizaje a toda la fuerza de trabajo y permite extraer métricas de rendimiento y progreso detalladas para cada sesión.
              <br/><br/>
              Esto se convierte en información accionable para RH.
              </>,
              <>
              The Inmersive training with VR and AR gives the same controlled conditions of training to all the workforce and allows detailed performance and progress metrics for each session.
              <br/><br/>
              This becomes actionable information for HR.
            </>)}
          </div>
        </Flex>
      </Flex>
      <Flex className="flexList flexListCompacta">
        <Flex className="columna">
          <div style={{}}>
            <h3 className="subHeader subHeaderSmall" style={{textAlign: 'left'}}>
              {l(<>Mejora continua</>,
                <>Continuous improvement</>)}
            </h3>
            {l(<>
              BP entrena en Realidad Virtual a sus empleados en tierra antes de llevarlos a plataformas petroleras donde la seguridad es crucial y la capacitación complicada.
              <br/><br/>
              El personal practica procesos en un entorno simulado seguro e inmersivo, donde ejecuta tareas manuales así como comunicación efectiva para reducir el error humano. 
              <br/><br/>
              BP monitorea las sesiones e identifica las partes más problemáticas para mejorar aún más.
              <br/><br/>
              Miles de trabajadores se han entrenado de esta forma, logrando un entorno más seguro con gran éxito.
            </>,
              <>
              BP trains its employees in Virtual Reality before taking them to oil platforms where safety is crucial and training is complicated.
              <br/><br/>
              The staff practices processes in a simulated secure and immersive environment, where they execute manual tasks as well as effective communication to reduce human error. 
              <br/><br/>
              BP monitors sessions and identifies the most problematic parts to improve even more.
              <br/><br/>  
              Thousands have trained this way, achieving a more secure environment with great success.
            </>)}
            <a href="https://www.bp.com/content/dam/bp/country-sites/en_us/united-states/home/documents/eir-2017/2017-bp-eir-saftey-single-pages.pdf" target='_blank' rel="noreferrer nofollow noopener">*</a>
          </div>
        </Flex>
        <Flex className="columna" >
          <div style={{borderRadius: '12px', overflow: 'hidden', marginTop: '1em', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/bpVirtualReality.jpg"
              alt={l('Plataforma petrolera en medio del océano', 'Oil platform in the middle of the ocean')}
              layout="fullWidth"
            />
            <StaticImage  {...MedImgProps}
              src="../../../content/images/servicios/capacitacion/bpVR.jpg"
              alt={l('Persona con lentes de realidad virtual y una pantalla con la simulación', 'Person with vr glasses and a screen with the simulation')}
              layout="fullWidth"
            />
          </div>
        </Flex>
      </Flex>
      <br/>
      <h3 className="subHeader subHeaderSmall" style={{textAlign: 'left'}}>
        {l(<>Uso global</>,
          <>Global usage</>)}
      </h3>
      <div className="contenidoSmall" style={{borderRadius: '12px', overflow: 'hidden', boxShadow: 'rgb(51 51 51 / 38%) 4px 6px 21px'}}>
        <StaticImage {...WideImgProps}
          src="../../../content/images/servicios/capacitacion/uso-capacitacion-virtual.jpg"
          alt={l('Mapa del mundo con logos de marcas que usan capacitacion con realidad virtual', 'Map of the world with logos of brands that use virtual reality training')}
          layout="fullWidth"
        />
      </div>
      <br/>
      <p>
        {l('Los beneficios del entrenamiento inmersivo y la capacitacion con realidad virtual han sido demostrados por empresas internacionales en distintos segmentos industriales.',
          'The benefits of inmersive training and virtual reality training have been demonstrated by international companies in different industrial segments.')}
      </p>
      <div className="contenidoSmall" style={{borderRadius: '12px', overflow: 'hidden', margin: '1.5em 0 0', width: '200px', maxWidth: '100%'}}>
        <StaticImage {...MedImgProps}
          src="../../../content/images/servicios/capacitacion/miniLogo-visualma.png"
          alt={l('Logo visualma', 'Logo visualma')}
          layout="fullWidth"
        />
      </div>
      <br/>
      <p>
        {l(<>
        Somos una empresa mexicana especializada en el desarrollo a la medida de proyectos de Realidad Virtual, Realidad Aumentada, Interactividad Inmersiva y Mapping 3D.
        <br/><br/>
        Tenemos más de 12 años de experiencia volviendo realidad los proyectos de clientes corporativos en un amplio rango de industrias.
        </>,
          <>
        We are a company specialized in the development custom projects of Virtual Reality, Augmented Reality, Immersive and Interactive experiences and 3D Mapping.
        <br/><br/>
        We have more than 12 years of experience with corporate projects in a wide range of industries.
        </>)}
      </p>
      <br/><br/>
      <h2 id="comoCrear" className="subHeader subHeaderSmall" style={{textAlign: 'left'}}>
        {l('Como crear una capacitación con realidad virtual',
           'How to create a virtual reality training')}
      </h2>
      <br/>
      <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', background: '#fefefe', fontSize: '0.8em'}}>
        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Análisis', 'Analysis')}
          </h5> 
        {l('De procesos y materiales existentes',
          'From existing processes and materials')}
        </div> 
        
        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Definición', 'Definition')}
          </h5>
        {l('De escenarios e interacciones', 
          'From scenarios and interactions')}
        </div>

        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Métricas', 'Metrics')}
          </h5>
        {l('Elección de parámetros de medición', 
          'Measurement parameters selection')}
        </div>

        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Diseño', 'Design')}
          </h5>
        {l('Programación y modelado de contenidos', 
          'Content modeling and programming')}
        </div>

        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Pruebas', 'Tests')}
          </h5>
        {l('Periodo piloto para perfeccionamiento', 
          'Pilot period')}
        </div>

        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Uso', 'Use')}
          </h5>
        {l('Se suma al resto de las herramientas de capacitación', 
          'It is added to the rest of the training tools')}
        </div>

        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Evaluación', 'Evaluation')}
          </h5>
        {l('Se comparan resultados con métricas', 
          'Results are compared with metrics')}
        </div>

        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Mejora continua', 'Continuous improvement')}
          </h5>
        {l('Ajustes para responder a nuevos retos',
          'Adjustments to respond to new challenges')} 
        </div>
      </div>
      <br/><br/>
      <h2 className="subHeader subHeaderSmall" style={{textAlign: 'left', fontSize: '12px'}}>
        {l('Datos necesarios', 'Required data')}
      </h2>
      <div style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', background: '#fefefe', fontSize: '0.8em'}}>
        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Objetivos', 'Objectives')}
          </h5>
          {l('Procesos específicos y objetivos de aprendizaje que se busca atacar mediante tecnologías de capacitacion con realidad virtual.', 
          'Specific processes and objectives to be targeted through virtual reality training technologies.')}
        </div>
        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Público', 'Audience')}
          </h5>
          {l('Comunicar características de los participantes como nivel de experiencia y conocimientos previos', 
          'Communicate the characteristics of the participants, their level of experience and previous knowledge')}
        </div>
        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Contenido', 'Content')}
          </h5>
          {l('Listar temas, procesos y tareas específicas a abarcar, e identificar qué interacciones se desea integrar.', 
          'List topics, processes and specific tasks to cover, and identify what interactions are desired to integrate.')}

        </div>
        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
          <h5 style={{textAlign: 'left', margin: '0.3em 0'}}>
            {l('Tiempo', 'Time')}
          </h5>
          {l('Definir la duración de la sesión, así como las fechas objetivo de lanzamiento.', 
          'Define the duration of the session, as well as the launch dates.')}

        </div>
        <div style={{border: '1px dotted #0000ff22', flex: '1 1 230px', padding: '16px'}}>
        <div>
          {l('Material de capacitación existente, referencias fotográficas y de vídeo de procesos y equipamento, son útiles para el análisis inicial y como material de soporte para el desarrollo de programas exitosos de capacitacion con VR.',
          'Existing training material, reference photos and video of processes and equipment are useful for the initial analysis and as support material for successful development of VR training programs.')}
        </div>
        </div>
      </div>
      
<br/><br/><br/><br/>

</div> {/* /mainContainer */}

<br/><br/>

        <ContactBanner lang={lang}/>

        <Proyectos lang={lang}
          title={l('Ejemplos de Realidad Virtual', 'Virtual Reality Examples')}
          category="Realidad Virtual"
          limit={3}
        />
        {l(<>
          <br /><br /><br />
          <Flex className="columna">
            <Heading as="h3" className="subHeader subHeaderSmall">
              Somos proveedores de Capacitación con Realidad Virtual y entrenamientos inmersivos en todo México
            </Heading>
            <Text fontSize="xl" className="parrafoChico">
              Hemos realizado instalaciónes y creado aplicaciónes de realidad
              virtual para empresas en Df / CDMX, Puebla,
              Monterrey, Guadalajara, Queretaro, Estado de México, Yucatán, Chihuahua, Tlaxcala, Veracruz, Oaxaca y muchos otros estados de la
              republica.
            </Text>
          </Flex>
          <br /><br />
        </>,
        null)}
      </div>
    </Layout>
  );
};
Capacitacion.propTypes = {
  lang: PropTypes.string,
};

export default Capacitacion;